module.exports = __webpack_public_path__ + "img/CL.65517b63.svg";